var _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _g3, _g4, _path7, _g5, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _g10, _path11, _g11, _g12, _path12, _g13, _g14, _path13, _g15, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAntiRaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 473,
    height: 252,
    viewBox: "0 0 473 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_1298)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.5 163C144.5 161.067 146.067 159.5 148 159.5H340C341.933 159.5 343.5 161.067 343.5 163V258.5H144.5V163Z",
    stroke: "#DFDFDF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343 163C343 161.343 341.657 160 340 160H175V259H343V163Z",
    fill: "#2E3035"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145 163C145 161.343 146.343 160 148 160H175V259H145V163Z",
    fill: "#2B2D31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M340 160H309C307.343 160 306 161.343 306 163V256C306 257.657 307.343 259 309 259H340C341.657 259 343 257.657 343 256V163C343 161.343 341.657 160 340 160Z",
    fill: "#2B2D31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.5 160V259",
    stroke: "#DFDFDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M306.5 160V259",
    stroke: "#DFDFDF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.5 49C255.822 49 265 39.8218 265 28.5C265 17.1782 255.822 8 244.5 8C233.178 8 224 17.1782 224 28.5C224 39.8218 233.178 49 244.5 49Z",
    fill: "#69B5E9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_204_1298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 229,
    y: 13,
    width: 31,
    height: 31
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260 28.5C260 19.9396 253.06 13 244.5 13C235.94 13 229 19.9396 229 28.5C229 37.0604 235.94 44 244.5 44C253.06 44 260 37.0604 260 28.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229 13H260V44H229V13Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.097 13H229V13.0969H229.097V13Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.281 33.3438H237.719V34.3125H251.281V33.3438ZM251.281 34.3125H237.719V35.2812H251.281V34.3125ZM251.281 35.2812H237.719V36.25H251.281V35.2812ZM251.281 36.25H237.719V37.2188H251.281V36.25ZM239.656 37.2188H237.719V38.1875H239.656V37.2188ZM251.281 37.2188H240.625V38.1875H251.281V37.2188ZM239.656 38.1875H237.719V39.1562H239.656V38.1875ZM251.281 38.1875H240.625V39.1562H251.281V38.1875ZM239.656 39.1562H237.719V40.125H239.656V39.1562ZM251.281 39.1562H240.625V40.125H251.281V39.1562ZM239.656 40.125H237.719V41.0938H239.656V40.125ZM251.281 40.125H240.625V41.0938H251.281V40.125ZM239.656 41.0938H237.719V42.0625H239.656V41.0938ZM251.281 41.0938H240.625V42.0625H251.281V41.0938ZM239.656 42.0625H237.719V43.0312H239.656V42.0625ZM251.281 42.0625H240.625V43.0312H251.281V42.0625ZM239.656 43.0312H237.719V44H239.656V43.0312ZM251.281 43.0312H240.625V44H251.281V43.0312Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.406 36.25H246.438V37.2188H247.406V36.25ZM245.469 37.2188H242.562V38.1875H245.469V37.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.438 37.2188H245.469V38.1875H246.438V37.2188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.406 37.2188H246.438V38.1875H247.406V37.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.375 37.2188H247.406V38.1875H248.375V37.2188Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.562 38.1875H241.594V39.1562H242.562V38.1875ZM244.5 38.1875H243.531V39.1562H244.5V38.1875Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.469 38.1875H244.5V39.1562H245.469V38.1875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.406 38.1875H245.469V39.1562H247.406V38.1875ZM242.562 39.1562H241.594V40.125H242.562V39.1562ZM244.5 39.1562H243.531V40.125H244.5V39.1562Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.438 39.1562H244.5V40.125H246.438V39.1562Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.406 39.1562H246.438V40.125H247.406V39.1562ZM244.5 40.125H243.531V41.0938H244.5V40.125ZM247.406 40.125H246.438V41.0938H247.406V40.125Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.562 15.9062H241.594V16.875H242.562V15.9062ZM246.438 15.9062H243.531V16.875H246.438V15.9062ZM247.406 16.875H240.625V17.8438H247.406V16.875ZM247.406 17.8438H239.656V18.8125H247.406V17.8438Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.625 18.8125H238.688V19.7812H240.625V18.8125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.406 18.8125H240.625V19.7812H247.406V18.8125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.312 18.8125H247.406V19.7812H250.312V18.8125ZM243.531 19.7812H237.719V20.75H243.531V19.7812Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.406 19.7812H243.531V20.75H247.406V19.7812Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.281 19.7812H247.406V20.75H251.281V19.7812ZM246.438 20.75H237.719V21.7188H246.438V20.75Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.406 20.75H246.438V21.7188H247.406V20.75Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.281 20.75H247.406V21.7188H251.281V20.75ZM252.25 21.7188H236.75V22.6875H252.25V21.7188ZM252.25 22.6875H236.75V23.6562H252.25V22.6875ZM252.25 23.6562H236.75V24.625H252.25V23.6562ZM252.25 24.625H236.75V25.5938H252.25V24.625ZM252.25 25.5938H236.75V26.5625H252.25V25.5938ZM252.25 26.5625H236.75V27.5312H252.25V26.5625ZM252.25 27.5312H236.75V28.5H252.25V27.5312ZM252.25 28.5H236.75V29.4688H252.25V28.5ZM244.5 29.4688H236.75V30.4375H244.5V29.4688Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.375 29.4688H244.5V30.4375H248.375V29.4688Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.25 29.4688H248.375V30.4375H252.25V29.4688ZM244.5 30.4375H236.75V31.4062H244.5V30.4375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.312 30.4375H244.5V31.4062H250.312V30.4375Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.25 30.4375H250.312V31.4062H252.25V30.4375ZM244.5 31.4062H236.75V32.375H244.5V31.4062Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.375 31.4062H244.5V32.375H248.375V31.4062Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.25 31.4062H248.375V32.375H252.25V31.4062ZM244.5 32.375H236.75V33.3438H244.5V32.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.375 32.375H244.5V33.3438H248.375V32.375Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.25 32.375H248.375V33.3438H252.25V32.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.5 23.6562H238.688V24.625H244.5V23.6562ZM251.281 23.6562H245.469V24.625H251.281V23.6562ZM239.656 24.625H238.688V25.5938H239.656V24.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.594 24.625H239.656V25.5938H241.594V24.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.531 24.625H241.594V25.5938H243.531V24.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.5 24.625H243.531V25.5938H244.5V24.625ZM246.438 24.625H245.469V25.5938H246.438V24.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.375 24.625H246.438V25.5938H248.375V24.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.312 24.625H248.375V25.5938H250.312V24.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.281 24.625H250.312V25.5938H251.281V24.625ZM239.656 25.5938H235.781V26.5625H239.656V25.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.594 25.5938H239.656V26.5625H241.594V25.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.531 25.5938H241.594V26.5625H243.531V25.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.438 25.5938H243.531V26.5625H246.438V25.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.375 25.5938H246.438V26.5625H248.375V25.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.312 25.5938H248.375V26.5625H250.312V25.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.281 25.5938H250.312V26.5625H251.281V25.5938ZM236.75 26.5625H235.781V27.5312H236.75V26.5625ZM239.656 26.5625H238.688V27.5312H239.656V26.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.594 26.5625H239.656V27.5312H241.594V26.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.531 26.5625H241.594V27.5312H243.531V26.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.5 26.5625H243.531V27.5312H244.5V26.5625ZM246.438 26.5625H245.469V27.5312H246.438V26.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.375 26.5625H246.438V27.5312H248.375V26.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.312 26.5625H248.375V27.5312H250.312V26.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.281 26.5625H250.312V27.5312H251.281V26.5625ZM236.75 27.5312H235.781V28.5H236.75V27.5312ZM239.656 27.5312H238.688V28.5H239.656V27.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.594 27.5312H239.656V28.5H241.594V27.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.531 27.5312H241.594V28.5H243.531V27.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.5 27.5312H243.531V28.5H244.5V27.5312ZM246.438 27.5312H245.469V28.5H246.438V27.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.375 27.5312H246.438V28.5H248.375V27.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.312 27.5312H248.375V28.5H250.312V27.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.281 27.5312H250.312V28.5H251.281V27.5312ZM244.5 28.5H238.688V29.4688H244.5V28.5ZM251.281 28.5H245.469V29.4688H251.281V28.5Z",
    fill: "#F3322C"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.5 65C150.822 65 160 55.8218 160 44.5C160 33.1782 150.822 24 139.5 24C128.178 24 119 33.1782 119 44.5C119 55.8218 128.178 65 139.5 65Z",
    fill: "#479E64"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_204_1298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 29,
    width: 31,
    height: 31
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155 44.5C155 35.9396 148.06 29 139.5 29C130.94 29 124 35.9396 124 44.5C124 53.0604 130.94 60 139.5 60C148.06 60 155 53.0604 155 44.5Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124 29H155V60H124V29Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.097 29H124V29.0969H124.097V29Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.281 49.3438H132.719V50.3125H146.281V49.3438ZM146.281 50.3125H132.719V51.2812H146.281V50.3125ZM146.281 51.2812H132.719V52.25H146.281V51.2812ZM146.281 52.25H132.719V53.2188H146.281V52.25ZM134.656 53.2188H132.719V54.1875H134.656V53.2188ZM146.281 53.2188H135.625V54.1875H146.281V53.2188ZM134.656 54.1875H132.719V55.1561H134.656V54.1875ZM146.281 54.1875H135.625V55.1561H146.281V54.1875ZM134.656 55.1561H132.719V56.125H134.656V55.1561ZM146.281 55.1561H135.625V56.125H146.281V55.1561ZM134.656 56.125H132.719V57.0938H134.656V56.125ZM146.281 56.125H135.625V57.0938H146.281V56.125ZM134.656 57.0938H132.719V58.0625H134.656V57.0938ZM146.281 57.0938H135.625V58.0625H146.281V57.0938ZM134.656 58.0625H132.719V59.0311H134.656V58.0625ZM146.281 58.0625H135.625V59.0311H146.281V58.0625ZM134.656 59.0311H132.719V60H134.656V59.0311ZM146.281 59.0311H135.625V60H146.281V59.0311Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.406 52.25H141.438V53.2188H142.406V52.25ZM140.469 53.2188H137.562V54.1875H140.469V53.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.438 53.2188H140.469V54.1875H141.438V53.2188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.406 53.2188H141.438V54.1875H142.406V53.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.375 53.2188H142.406V54.1875H143.375V53.2188Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.562 54.1875H136.594V55.1562H137.562V54.1875ZM139.5 54.1875H138.531V55.1562H139.5V54.1875Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.469 54.1875H139.5V55.1562H140.469V54.1875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.406 54.1875H140.469V55.1562H142.406V54.1875ZM137.562 55.1562H136.594V56.125H137.562V55.1562ZM139.5 55.1562H138.531V56.125H139.5V55.1562Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.438 55.1562H139.5V56.1251H141.438V55.1562Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.406 55.1562H141.438V56.1251H142.406V55.1562ZM139.5 56.1251H138.531V57.0939H139.5V56.1251ZM142.406 56.1251H141.438V57.0939H142.406V56.1251Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.562 31.9062H136.594V32.875H137.562V31.9062ZM141.438 31.9062H138.531V32.875H141.438V31.9062ZM142.406 32.875H135.625V33.8438H142.406V32.875ZM142.406 33.8438H134.656V34.8125H142.406V33.8438Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.625 34.8125H133.688V35.7812H135.625V34.8125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.406 34.8125H135.625V35.7812H142.406V34.8125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 34.8125H142.406V35.7812H145.312V34.8125ZM138.531 35.7812H132.719V36.75H138.531V35.7812Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.406 35.7812H138.531V36.75H142.406V35.7812Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.281 35.7812H142.406V36.75H146.281V35.7812ZM141.438 36.75H132.719V37.7188H141.438V36.75Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.406 36.75H141.438V37.7188H142.406V36.75Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.281 36.75H142.406V37.7188H146.281V36.75ZM147.25 37.7188H131.75V38.6875H147.25V37.7188ZM147.25 38.6875H131.75V39.6562H147.25V38.6875ZM147.25 39.6562H131.75V40.625H147.25V39.6562ZM147.25 40.625H131.75V41.5938H147.25V40.625ZM147.25 41.5938H131.75V42.5625H147.25V41.5938ZM147.25 42.5625H131.75V43.5312H147.25V42.5625ZM147.25 43.5312H131.75V44.5H147.25V43.5312ZM147.25 44.5H131.75V45.4688H147.25V44.5ZM139.5 45.4688H131.75V46.4375H139.5V45.4688Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.375 45.4688H139.5V46.4375H143.375V45.4688Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25 45.4688H143.375V46.4375H147.25V45.4688ZM139.5 46.4375H131.75V47.4062H139.5V46.4375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 46.4375H139.5V47.4062H145.312V46.4375Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25 46.4375H145.312V47.4062H147.25V46.4375ZM139.5 47.4062H131.75V48.375H139.5V47.4062Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.375 47.4062H139.5V48.375H143.375V47.4062Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25 47.4062H143.375V48.375H147.25V47.4062ZM139.5 48.375H131.75V49.3438H139.5V48.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.375 48.375H139.5V49.3438H143.375V48.375Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25 48.375H143.375V49.3438H147.25V48.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 39.6562H133.688V40.625H139.5V39.6562ZM146.281 39.6562H140.469V40.625H146.281V39.6562ZM134.656 40.625H133.688V41.5938H134.656V40.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.594 40.625H134.656V41.5938H136.594V40.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.531 40.625H136.594V41.5938H138.531V40.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 40.625H138.531V41.5938H139.5V40.625ZM141.438 40.625H140.469V41.5938H141.438V40.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.375 40.625H141.438V41.5938H143.375V40.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 40.625H143.375V41.5938H145.312V40.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.281 40.625H145.312V41.5938H146.281V40.625ZM134.656 41.5938H130.781V42.5625H134.656V41.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.594 41.5938H134.656V42.5625H136.594V41.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.531 41.5938H136.594V42.5625H138.531V41.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.438 41.5938H138.531V42.5625H141.438V41.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.375 41.5938H141.438V42.5625H143.375V41.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 41.5938H143.375V42.5625H145.312V41.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.281 41.5938H145.312V42.5625H146.281V41.5938ZM131.75 42.5625H130.781V43.5312H131.75V42.5625ZM134.656 42.5625H133.688V43.5312H134.656V42.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.594 42.5625H134.656V43.5312H136.594V42.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.531 42.5625H136.594V43.5312H138.531V42.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 42.5625H138.531V43.5312H139.5V42.5625ZM141.438 42.5625H140.469V43.5312H141.438V42.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.375 42.5625H141.438V43.5312H143.375V42.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 42.5625H143.375V43.5312H145.312V42.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.281 42.5625H145.312V43.5312H146.281V42.5625ZM131.75 43.5312H130.781V44.5H131.75V43.5312ZM134.656 43.5312H133.688V44.5H134.656V43.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.594 43.5312H134.656V44.5H136.594V43.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.531 43.5312H136.594V44.5H138.531V43.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 43.5312H138.531V44.5H139.5V43.5312ZM141.438 43.5312H140.469V44.5H141.438V43.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.375 43.5312H141.438V44.5H143.375V43.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 43.5312H143.375V44.5H145.312V43.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.281 43.5312H145.312V44.5H146.281V43.5312ZM139.5 44.5H133.688V45.4688H139.5V44.5ZM146.281 44.5H140.469V45.4688H146.281V44.5Z",
    fill: "#F3322C"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 79C47.8218 79 57 69.8218 57 58.5C57 47.1782 47.8218 38 36.5 38C25.1782 38 16 47.1782 16 58.5C16 69.8218 25.1782 79 36.5 79Z",
    fill: "#D7AD3D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_204_1298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 43,
    width: 31,
    height: 31
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58.5C52 49.9396 45.0604 43 36.5 43C27.9396 43 21 49.9396 21 58.5C21 67.0604 27.9396 74 36.5 74C45.0604 74 52 67.0604 52 58.5Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 43H52V74H21V43Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0969 43H21V43.0969H21.0969V43Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 63.3438H29.7188V64.3124H43.2812V63.3438ZM43.2812 64.3124H29.7188V65.2811H43.2812V64.3124ZM43.2812 65.2811H29.7188V66.2499H43.2812V65.2811ZM43.2812 66.2499H29.7188V67.2188H43.2812V66.2499ZM31.6562 67.2188H29.7188V68.1874H31.6562V67.2188ZM43.2812 67.2188H32.625V68.1874H43.2812V67.2188ZM31.6562 68.1874H29.7188V69.1561H31.6562V68.1874ZM43.2812 68.1874H32.625V69.1561H43.2812V68.1874ZM31.6562 69.1561H29.7188V70.1249H31.6562V69.1561ZM43.2812 69.1561H32.625V70.1249H43.2812V69.1561ZM31.6562 70.1249H29.7188V71.0938H31.6562V70.1249ZM43.2812 70.1249H32.625V71.0938H43.2812V70.1249ZM31.6562 71.0938H29.7188V72.0624H31.6562V71.0938ZM43.2812 71.0938H32.625V72.0624H43.2812V71.0938ZM31.6562 72.0624H29.7188V73.0311H31.6562V72.0624ZM43.2812 72.0624H32.625V73.0311H43.2812V72.0624ZM31.6562 73.0311H29.7188V73.9999H31.6562V73.0311ZM43.2812 73.0311H32.625V73.9999H43.2812V73.0311Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4062 66.25H38.4375V67.2188H39.4062V66.25ZM37.4688 67.2188H34.5625V68.1875H37.4688V67.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4375 67.2188H37.4688V68.1874H38.4375V67.2188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4062 67.2188H38.4375V68.1874H39.4062V67.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.375 67.2188H39.4062V68.1874H40.375V67.2188Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5625 68.1875H33.5938V69.1562H34.5625V68.1875ZM36.5 68.1875H35.5312V69.1562H36.5V68.1875Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4688 68.1875H36.5V69.1562H37.4688V68.1875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4062 68.1875H37.4688V69.1562H39.4062V68.1875ZM34.5625 69.1562H33.5938V70.125H34.5625V69.1562ZM36.5 69.1562H35.5312V70.125H36.5V69.1562Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4375 69.1562H36.5V70.1251H38.4375V69.1562Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4062 69.1562H38.4375V70.1251H39.4062V69.1562ZM36.5 70.1251H35.5312V71.0939H36.5V70.1251ZM39.4062 70.1251H38.4375V71.0939H39.4062V70.1251Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5625 45.9062H33.5938V46.875H34.5625V45.9062ZM38.4375 45.9062H35.5312V46.875H38.4375V45.9062ZM39.4062 46.875H32.625V47.8438H39.4062V46.875ZM39.4062 47.8438H31.6562V48.8125H39.4062V47.8438Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.625 48.8125H30.6875V49.7812H32.625V48.8125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4062 48.8125H32.625V49.7812H39.4062V48.8125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3125 48.8125H39.4062V49.7812H42.3125V48.8125ZM35.5312 49.7812H29.7188V50.75H35.5312V49.7812Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4062 49.7812H35.5312V50.75H39.4062V49.7812Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 49.7812H39.4062V50.75H43.2812V49.7812ZM38.4375 50.75H29.7188V51.7188H38.4375V50.75Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4062 50.75H38.4375V51.7188H39.4062V50.75Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 50.75H39.4062V51.7188H43.2812V50.75ZM44.25 51.7188H28.75V52.6875H44.25V51.7188ZM44.25 52.6875H28.75V53.6562H44.25V52.6875ZM44.25 53.6562H28.75V54.625H44.25V53.6562ZM44.25 54.625H28.75V55.5938H44.25V54.625ZM44.25 55.5938H28.75V56.5625H44.25V55.5938ZM44.25 56.5625H28.75V57.5312H44.25V56.5625ZM44.25 57.5312H28.75V58.5H44.25V57.5312ZM44.25 58.5H28.75V59.4688H44.25V58.5ZM36.5 59.4688H28.75V60.4375H36.5V59.4688Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.375 59.4688H36.5V60.4374H40.375V59.4688Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25 59.4688H40.375V60.4374H44.25V59.4688ZM36.5 60.4374H28.75V61.4061H36.5V60.4374Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3125 60.4375H36.5V61.4062H42.3125V60.4375Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25 60.4375H42.3125V61.4062H44.25V60.4375ZM36.5 61.4062H28.75V62.375H36.5V61.4062Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.375 61.4062H36.5V62.3751H40.375V61.4062Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25 61.4062H40.375V62.3751H44.25V61.4062ZM36.5 62.3751H28.75V63.3439H36.5V62.3751Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.375 62.375H36.5V63.3438H40.375V62.375Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25 62.375H40.375V63.3438H44.25V62.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 53.6562H30.6875V54.625H36.5V53.6562ZM43.2812 53.6562H37.4688V54.625H43.2812V53.6562ZM31.6562 54.625H30.6875V55.5939H31.6562V54.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5938 54.625H31.6562V55.5938H33.5938V54.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5312 54.625H33.5938V55.5938H35.5312V54.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 54.625H35.5312V55.5938H36.5V54.625ZM38.4375 54.625H37.4688V55.5938H38.4375V54.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.375 54.625H38.4375V55.5938H40.375V54.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3125 54.625H40.375V55.5938H42.3125V54.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 54.625H42.3125V55.5938H43.2812V54.625ZM31.6562 55.5938H27.7812V56.5625H31.6562V55.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5938 55.5938H31.6562V56.5624H33.5938V55.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5312 55.5938H33.5938V56.5624H35.5312V55.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4375 55.5938H35.5312V56.5624H38.4375V55.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.375 55.5938H38.4375V56.5624H40.375V55.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3125 55.5938H40.375V56.5624H42.3125V55.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 55.5938H42.3125V56.5624H43.2812V55.5938ZM28.75 56.5624H27.7812V57.5311H28.75V56.5624ZM31.6562 56.5624H30.6875V57.5311H31.6562V56.5624Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5938 56.5625H31.6562V57.5312H33.5938V56.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5312 56.5625H33.5938V57.5312H35.5312V56.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 56.5625H35.5312V57.5312H36.5V56.5625ZM38.4375 56.5625H37.4688V57.5312H38.4375V56.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.375 56.5625H38.4375V57.5312H40.375V56.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3125 56.5625H40.375V57.5312H42.3125V56.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 56.5625H42.3125V57.5312H43.2812V56.5625ZM28.75 57.5312H27.7812V58.5H28.75V57.5312ZM31.6562 57.5312H30.6875V58.5H31.6562V57.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5938 57.5312H31.6562V58.5001H33.5938V57.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5312 57.5312H33.5938V58.5001H35.5312V57.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 57.5312H35.5312V58.5001H36.5V57.5312ZM38.4375 57.5312H37.4688V58.5001H38.4375V57.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.375 57.5312H38.4375V58.5001H40.375V57.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3125 57.5312H40.375V58.5001H42.3125V57.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 57.5312H42.3125V58.5001H43.2812V57.5312ZM36.5 58.5001H30.6875V59.4689H36.5V58.5001ZM43.2812 58.5001H37.4688V59.4689H43.2812V58.5001Z",
    fill: "#F3322C"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 201C33.8218 201 43 191.822 43 180.5C43 169.178 33.8218 160 22.5 160C11.1782 160 2 169.178 2 180.5C2 191.822 11.1782 201 22.5 201Z",
    fill: "#333333"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 201C33.8218 201 43 191.822 43 180.5C43 169.178 33.8218 160 22.5 160C11.1782 160 2 169.178 2 180.5C2 191.822 11.1782 201 22.5 201Z",
    fill: "#C63B32"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_204_1298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 165,
    width: 31,
    height: 31
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38 180.5C38 171.94 31.0604 165 22.5 165C13.9396 165 7 171.94 7 180.5C7 189.06 13.9396 196 22.5 196C31.0604 196 38 189.06 38 180.5Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 165H38V196H7V165Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09687 165H7V165.097H7.09687V165Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2812 185.344H15.7188V186.312H29.2812V185.344ZM29.2812 186.312H15.7188V187.281H29.2812V186.312ZM29.2812 187.281H15.7188V188.25H29.2812V187.281ZM29.2812 188.25H15.7188V189.219H29.2812V188.25ZM17.6562 189.219H15.7188V190.188H17.6562V189.219ZM29.2812 189.219H18.625V190.188H29.2812V189.219ZM17.6562 190.188H15.7188V191.156H17.6562V190.188ZM29.2812 190.188H18.625V191.156H29.2812V190.188ZM17.6562 191.156H15.7188V192.125H17.6562V191.156ZM29.2812 191.156H18.625V192.125H29.2812V191.156ZM17.6562 192.125H15.7188V193.094H17.6562V192.125ZM29.2812 192.125H18.625V193.094H29.2812V192.125ZM17.6562 193.094H15.7188V194.062H17.6562V193.094ZM29.2812 193.094H18.625V194.062H29.2812V193.094ZM17.6562 194.062H15.7188V195.031H17.6562V194.062ZM29.2812 194.062H18.625V195.031H29.2812V194.062ZM17.6562 195.031H15.7188V196H17.6562V195.031ZM29.2812 195.031H18.625V196H29.2812V195.031Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4062 188.25H24.4375V189.219H25.4062V188.25ZM23.4688 189.219H20.5625V190.188H23.4688V189.219Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 189.219H23.4688V190.188H24.4375V189.219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4062 189.219H24.4375V190.188H25.4062V189.219Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 189.219H25.4062V190.188H26.375V189.219Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 190.188H19.5938V191.156H20.5625V190.188ZM22.5 190.188H21.5312V191.156H22.5V190.188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4688 190.188H22.5V191.156H23.4688V190.188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4062 190.188H23.4688V191.156H25.4062V190.188ZM20.5625 191.156H19.5938V192.125H20.5625V191.156ZM22.5 191.156H21.5312V192.125H22.5V191.156Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 191.156H22.5V192.125H24.4375V191.156Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4062 191.156H24.4375V192.125H25.4062V191.156ZM22.5 192.125H21.5312V193.094H22.5V192.125ZM25.4062 192.125H24.4375V193.094H25.4062V192.125Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 167.906H19.5938V168.875H20.5625V167.906ZM24.4375 167.906H21.5312V168.875H24.4375V167.906ZM25.4062 168.875H18.625V169.844H25.4062V168.875ZM25.4062 169.844H17.6562V170.812H25.4062V169.844Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.625 170.812H16.6875V171.781H18.625V170.812Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4062 170.812H18.625V171.781H25.4062V170.812Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3125 170.812H25.4062V171.781H28.3125V170.812ZM21.5312 171.781H15.7188V172.75H21.5312V171.781Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4062 171.781H21.5312V172.75H25.4062V171.781Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2812 171.781H25.4062V172.75H29.2812V171.781ZM24.4375 172.75H15.7188V173.719H24.4375V172.75Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4062 172.75H24.4375V173.719H25.4062V172.75Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2812 172.75H25.4062V173.719H29.2812V172.75ZM30.25 173.719H14.75V174.688H30.25V173.719ZM30.25 174.688H14.75V175.656H30.25V174.688ZM30.25 175.656H14.75V176.625H30.25V175.656ZM30.25 176.625H14.75V177.594H30.25V176.625ZM30.25 177.594H14.75V178.562H30.25V177.594ZM30.25 178.562H14.75V179.531H30.25V178.562ZM30.25 179.531H14.75V180.5H30.25V179.531ZM30.25 180.5H14.75V181.469H30.25V180.5ZM22.5 181.469H14.75V182.438H22.5V181.469Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 181.469H22.5V182.438H26.375V181.469Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25 181.469H26.375V182.438H30.25V181.469ZM22.5 182.438H14.75V183.406H22.5V182.438Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3125 182.438H22.5V183.406H28.3125V182.438Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25 182.438H28.3125V183.406H30.25V182.438ZM22.5 183.406H14.75V184.375H22.5V183.406Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 183.406H22.5V184.375H26.375V183.406Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25 183.406H26.375V184.375H30.25V183.406ZM22.5 184.375H14.75V185.344H22.5V184.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 184.375H22.5V185.344H26.375V184.375Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25 184.375H26.375V185.344H30.25V184.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 175.656H16.6875V176.625H22.5V175.656ZM29.2812 175.656H23.4688V176.625H29.2812V175.656ZM17.6562 176.625H16.6875V177.594H17.6562V176.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 176.625H17.6562V177.594H19.5938V176.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 176.625H19.5938V177.594H21.5312V176.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 176.625H21.5312V177.594H22.5V176.625ZM24.4375 176.625H23.4688V177.594H24.4375V176.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 176.625H24.4375V177.594H26.375V176.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3125 176.625H26.375V177.594H28.3125V176.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2812 176.625H28.3125V177.594H29.2812V176.625ZM17.6562 177.594H13.7812V178.562H17.6562V177.594Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 177.594H17.6562V178.562H19.5938V177.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 177.594H19.5938V178.562H21.5312V177.594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 177.594H21.5312V178.562H24.4375V177.594Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 177.594H24.4375V178.562H26.375V177.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3125 177.594H26.375V178.562H28.3125V177.594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2812 177.594H28.3125V178.562H29.2812V177.594ZM14.75 178.562H13.7812V179.531H14.75V178.562ZM17.6562 178.562H16.6875V179.531H17.6562V178.562Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 178.562H17.6562V179.531H19.5938V178.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 178.562H19.5938V179.531H21.5312V178.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 178.562H21.5312V179.531H22.5V178.562ZM24.4375 178.562H23.4688V179.531H24.4375V178.562Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 178.562H24.4375V179.531H26.375V178.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3125 178.562H26.375V179.531H28.3125V178.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2812 178.562H28.3125V179.531H29.2812V178.562ZM14.75 179.531H13.7812V180.5H14.75V179.531ZM17.6562 179.531H16.6875V180.5H17.6562V179.531Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 179.531H17.6562V180.5H19.5938V179.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 179.531H19.5938V180.5H21.5312V179.531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 179.531H21.5312V180.5H22.5V179.531ZM24.4375 179.531H23.4688V180.5H24.4375V179.531Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 179.531H24.4375V180.5H26.375V179.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3125 179.531H26.375V180.5H28.3125V179.531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2812 179.531H28.3125V180.5H29.2812V179.531ZM22.5 180.5H16.6875V181.469H22.5V180.5ZM29.2812 180.5H23.4688V181.469H29.2812V180.5Z",
    fill: "#F3322C"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.5 41C353.822 41 363 31.8218 363 20.5C363 9.17816 353.822 0 342.5 0C331.178 0 322 9.17816 322 20.5C322 31.8218 331.178 41 342.5 41Z",
    fill: "#C63B32"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_204_1298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 327,
    y: 5,
    width: 31,
    height: 31
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M358 20.5C358 11.9396 351.06 5 342.5 5C333.94 5 327 11.9396 327 20.5C327 29.0604 333.94 36 342.5 36C351.06 36 358 29.0604 358 20.5Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327 5H358V36H327V5Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.097 5H327V5.0969H327.097V5Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.281 25.3438H335.719V26.3125H349.281V25.3438ZM349.281 26.3125H335.719V27.2812H349.281V26.3125ZM349.281 27.2812H335.719V28.25H349.281V27.2812ZM349.281 28.25H335.719V29.2188H349.281V28.25ZM337.656 29.2188H335.719V30.1875H337.656V29.2188ZM349.281 29.2188H338.625V30.1875H349.281V29.2188ZM337.656 30.1875H335.719V31.1562H337.656V30.1875ZM349.281 30.1875H338.625V31.1562H349.281V30.1875ZM337.656 31.1562H335.719V32.125H337.656V31.1562ZM349.281 31.1562H338.625V32.125H349.281V31.1562ZM337.656 32.125H335.719V33.0938H337.656V32.125ZM349.281 32.125H338.625V33.0938H349.281V32.125ZM337.656 33.0938H335.719V34.0625H337.656V33.0938ZM349.281 33.0938H338.625V34.0625H349.281V33.0938ZM337.656 34.0625H335.719V35.0312H337.656V34.0625ZM349.281 34.0625H338.625V35.0312H349.281V34.0625ZM337.656 35.0312H335.719V36H337.656V35.0312ZM349.281 35.0312H338.625V36H349.281V35.0312Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.406 28.25H344.438V29.2188H345.406V28.25ZM343.469 29.2188H340.562V30.1875H343.469V29.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.438 29.2188H343.469V30.1875H344.438V29.2188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.406 29.2188H344.438V30.1875H345.406V29.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.375 29.2188H345.406V30.1875H346.375V29.2188Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.562 30.1875H339.594V31.1562H340.562V30.1875ZM342.5 30.1875H341.531V31.1562H342.5V30.1875Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.469 30.1875H342.5V31.1562H343.469V30.1875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.406 30.1875H343.469V31.1562H345.406V30.1875ZM340.562 31.1562H339.594V32.125H340.562V31.1562ZM342.5 31.1562H341.531V32.125H342.5V31.1562Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.438 31.1562H342.5V32.125H344.438V31.1562Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.406 31.1562H344.438V32.125H345.406V31.1562ZM342.5 32.125H341.531V33.0938H342.5V32.125ZM345.406 32.125H344.438V33.0938H345.406V32.125Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.562 7.90625H339.594V8.87505H340.562V7.90625ZM344.438 7.90625H341.531V8.87505H344.438V7.90625ZM345.406 8.87505H338.625V9.84385H345.406V8.87505ZM345.406 9.84385H337.656V10.8125H345.406V9.84385Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.625 10.8125H336.688V11.7812H338.625V10.8125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.406 10.8125H338.625V11.7812H345.406V10.8125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.312 10.8125H345.406V11.7812H348.312V10.8125ZM341.531 11.7812H335.719V12.75H341.531V11.7812Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.406 11.7812H341.531V12.75H345.406V11.7812Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.281 11.7812H345.406V12.75H349.281V11.7812ZM344.438 12.75H335.719V13.7188H344.438V12.75Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.406 12.75H344.438V13.7188H345.406V12.75Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.281 12.75H345.406V13.7188H349.281V12.75ZM350.25 13.7188H334.75V14.6875H350.25V13.7188ZM350.25 14.6875H334.75V15.6562H350.25V14.6875ZM350.25 15.6562H334.75V16.625H350.25V15.6562ZM350.25 16.625H334.75V17.5938H350.25V16.625ZM350.25 17.5938H334.75V18.5625H350.25V17.5938ZM350.25 18.5625H334.75V19.5312H350.25V18.5625ZM350.25 19.5312H334.75V20.5H350.25V19.5312ZM350.25 20.5H334.75V21.4688H350.25V20.5ZM342.5 21.4688H334.75V22.4375H342.5V21.4688Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.375 21.4688H342.5V22.4375H346.375V21.4688Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.25 21.4688H346.375V22.4375H350.25V21.4688ZM342.5 22.4375H334.75V23.4062H342.5V22.4375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.312 22.4375H342.5V23.4062H348.312V22.4375Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.25 22.4375H348.312V23.4062H350.25V22.4375ZM342.5 23.4062H334.75V24.375H342.5V23.4062Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.375 23.4062H342.5V24.375H346.375V23.4062Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.25 23.4062H346.375V24.375H350.25V23.4062ZM342.5 24.375H334.75V25.3438H342.5V24.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.375 24.375H342.5V25.3438H346.375V24.375Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.25 24.375H346.375V25.3438H350.25V24.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 15.6562H336.688V16.625H342.5V15.6562ZM349.281 15.6562H343.469V16.625H349.281V15.6562ZM337.656 16.625H336.688V17.5938H337.656V16.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.594 16.625H337.656V17.5938H339.594V16.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.531 16.625H339.594V17.5938H341.531V16.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 16.625H341.531V17.5938H342.5V16.625ZM344.438 16.625H343.469V17.5938H344.438V16.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.375 16.625H344.438V17.5938H346.375V16.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.312 16.625H346.375V17.5938H348.312V16.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.281 16.625H348.312V17.5938H349.281V16.625ZM337.656 17.5938H333.781V18.5625H337.656V17.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.594 17.5938H337.656V18.5625H339.594V17.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.531 17.5938H339.594V18.5625H341.531V17.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.438 17.5938H341.531V18.5625H344.438V17.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.375 17.5938H344.438V18.5625H346.375V17.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.312 17.5938H346.375V18.5625H348.312V17.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.281 17.5938H348.312V18.5625H349.281V17.5938ZM334.75 18.5625H333.781V19.5312H334.75V18.5625ZM337.656 18.5625H336.688V19.5312H337.656V18.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.594 18.5625H337.656V19.5312H339.594V18.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.531 18.5625H339.594V19.5312H341.531V18.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 18.5625H341.531V19.5312H342.5V18.5625ZM344.438 18.5625H343.469V19.5312H344.438V18.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.375 18.5625H344.438V19.5312H346.375V18.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.312 18.5625H346.375V19.5312H348.312V18.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.281 18.5625H348.312V19.5312H349.281V18.5625ZM334.75 19.5312H333.781V20.5H334.75V19.5312ZM337.656 19.5312H336.688V20.5H337.656V19.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.594 19.5312H337.656V20.5H339.594V19.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.531 19.5312H339.594V20.5H341.531V19.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 19.5312H341.531V20.5H342.5V19.5312ZM344.438 19.5312H343.469V20.5H344.438V19.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.375 19.5312H344.438V20.5H346.375V19.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.312 19.5312H346.375V20.5H348.312V19.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.281 19.5312H348.312V20.5H349.281V19.5312ZM342.5 20.5H336.688V21.4688H342.5V20.5ZM349.281 20.5H343.469V21.4688H349.281V20.5Z",
    fill: "#F3322C"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.5 74C435.822 74 445 64.8218 445 53.5C445 42.1782 435.822 33 424.5 33C413.178 33 404 42.1782 404 53.5C404 64.8218 413.178 74 424.5 74Z",
    fill: "#A45D81"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_204_1298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 409,
    y: 38,
    width: 31,
    height: 31
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M440 53.5C440 44.9396 433.06 38 424.5 38C415.94 38 409 44.9396 409 53.5C409 62.0604 415.94 69 424.5 69C433.06 69 440 62.0604 440 53.5Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409 38H440V69H409V38Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.097 38H409V38.0969H409.097V38Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.281 58.3438H417.719V59.3124H431.281V58.3438ZM431.281 59.3124H417.719V60.2811H431.281V59.3124ZM431.281 60.2811H417.719V61.2499H431.281V60.2811ZM431.281 61.2499H417.719V62.2188H431.281V61.2499ZM419.656 62.2188H417.719V63.1874H419.656V62.2188ZM431.281 62.2188H420.625V63.1874H431.281V62.2188ZM419.656 63.1874H417.719V64.1561H419.656V63.1874ZM431.281 63.1874H420.625V64.1561H431.281V63.1874ZM419.656 64.1561H417.719V65.1249H419.656V64.1561ZM431.281 64.1561H420.625V65.1249H431.281V64.1561ZM419.656 65.1249H417.719V66.0938H419.656V65.1249ZM431.281 65.1249H420.625V66.0938H431.281V65.1249ZM419.656 66.0938H417.719V67.0624H419.656V66.0938ZM431.281 66.0938H420.625V67.0624H431.281V66.0938ZM419.656 67.0624H417.719V68.0311H419.656V67.0624ZM431.281 67.0624H420.625V68.0311H431.281V67.0624ZM419.656 68.0311H417.719V68.9999H419.656V68.0311ZM431.281 68.0311H420.625V68.9999H431.281V68.0311Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.406 61.25H426.438V62.2188H427.406V61.25ZM425.469 62.2188H422.562V63.1875H425.469V62.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.438 62.2188H425.469V63.1874H426.438V62.2188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.406 62.2188H426.438V63.1874H427.406V62.2188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.375 62.2188H427.406V63.1874H428.375V62.2188Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.562 63.1875H421.594V64.1562H422.562V63.1875ZM424.5 63.1875H423.531V64.1562H424.5V63.1875Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.469 63.1875H424.5V64.1562H425.469V63.1875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.406 63.1875H425.469V64.1562H427.406V63.1875ZM422.562 64.1562H421.594V65.125H422.562V64.1562ZM424.5 64.1562H423.531V65.125H424.5V64.1562Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.438 64.1562H424.5V65.1251H426.438V64.1562Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.406 64.1562H426.438V65.1251H427.406V64.1562ZM424.5 65.1251H423.531V66.0939H424.5V65.1251ZM427.406 65.1251H426.438V66.0939H427.406V65.1251Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.562 40.9062H421.594V41.875H422.562V40.9062ZM426.438 40.9062H423.531V41.875H426.438V40.9062ZM427.406 41.875H420.625V42.8438H427.406V41.875ZM427.406 42.8438H419.656V43.8125H427.406V42.8438Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.625 43.8125H418.688V44.7812H420.625V43.8125Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.406 43.8125H420.625V44.7812H427.406V43.8125Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.312 43.8125H427.406V44.7812H430.312V43.8125ZM423.531 44.7812H417.719V45.75H423.531V44.7812Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.406 44.7812H423.531V45.75H427.406V44.7812Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.281 44.7812H427.406V45.75H431.281V44.7812ZM426.438 45.75H417.719V46.7188H426.438V45.75Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.406 45.75H426.438V46.7188H427.406V45.75Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.281 45.75H427.406V46.7188H431.281V45.75ZM432.25 46.7188H416.75V47.6875H432.25V46.7188ZM432.25 47.6875H416.75V48.6562H432.25V47.6875ZM432.25 48.6562H416.75V49.625H432.25V48.6562ZM432.25 49.625H416.75V50.5938H432.25V49.625ZM432.25 50.5938H416.75V51.5625H432.25V50.5938ZM432.25 51.5625H416.75V52.5312H432.25V51.5625ZM432.25 52.5312H416.75V53.5H432.25V52.5312ZM432.25 53.5H416.75V54.4688H432.25V53.5ZM424.5 54.4688H416.75V55.4375H424.5V54.4688Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.375 54.4688H424.5V55.4374H428.375V54.4688Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.25 54.4688H428.375V55.4374H432.25V54.4688ZM424.5 55.4374H416.75V56.4061H424.5V55.4374Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.312 55.4375H424.5V56.4062H430.312V55.4375Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.25 55.4375H430.312V56.4062H432.25V55.4375ZM424.5 56.4062H416.75V57.375H424.5V56.4062Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.375 56.4062H424.5V57.3751H428.375V56.4062Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.25 56.4062H428.375V57.3751H432.25V56.4062ZM424.5 57.3751H416.75V58.3439H424.5V57.3751Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.375 57.375H424.5V58.3438H428.375V57.375Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.25 57.375H428.375V58.3438H432.25V57.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.5 48.6562H418.688V49.625H424.5V48.6562ZM431.281 48.6562H425.469V49.625H431.281V48.6562ZM419.656 49.625H418.688V50.5938H419.656V49.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.594 49.625H419.656V50.5938H421.594V49.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.531 49.625H421.594V50.5938H423.531V49.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.5 49.625H423.531V50.5938H424.5V49.625ZM426.438 49.625H425.469V50.5938H426.438V49.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.375 49.625H426.438V50.5938H428.375V49.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.312 49.625H428.375V50.5938H430.312V49.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.281 49.625H430.312V50.5938H431.281V49.625ZM419.656 50.5938H415.781V51.5625H419.656V50.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.594 50.5938H419.656V51.5625H421.594V50.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.531 50.5938H421.594V51.5625H423.531V50.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.438 50.5938H423.531V51.5625H426.438V50.5938Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.375 50.5938H426.438V51.5625H428.375V50.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.312 50.5938H428.375V51.5625H430.312V50.5938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.281 50.5938H430.312V51.5625H431.281V50.5938ZM416.75 51.5625H415.781V52.5312H416.75V51.5625ZM419.656 51.5625H418.688V52.5312H419.656V51.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.594 51.5625H419.656V52.5312H421.594V51.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.531 51.5625H421.594V52.5312H423.531V51.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.5 51.5625H423.531V52.5312H424.5V51.5625ZM426.438 51.5625H425.469V52.5312H426.438V51.5625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.375 51.5625H426.438V52.5312H428.375V51.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.312 51.5625H428.375V52.5312H430.312V51.5625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.281 51.5625H430.312V52.5312H431.281V51.5625ZM416.75 52.5312H415.781V53.5H416.75V52.5312ZM419.656 52.5312H418.688V53.5H419.656V52.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.594 52.5312H419.656V53.5H421.594V52.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.531 52.5312H421.594V53.5H423.531V52.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.5 52.5312H423.531V53.5H424.5V52.5312ZM426.438 52.5312H425.469V53.5H426.438V52.5312Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.375 52.5312H426.438V53.5H428.375V52.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.312 52.5312H428.375V53.5H430.312V52.5312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.281 52.5312H430.312V53.5H431.281V52.5312ZM424.5 53.5H418.688V54.4689H424.5V53.5ZM431.281 53.5H425.469V54.4689H431.281V53.5Z",
    fill: "#F3322C"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.5 199C463.822 199 473 189.822 473 178.5C473 167.178 463.822 158 452.5 158C441.178 158 432 167.178 432 178.5C432 189.822 441.178 199 452.5 199Z",
    fill: "#479E64"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_204_1298",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 437,
    y: 163,
    width: 31,
    height: 31
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M468 178.5C468 169.94 461.06 163 452.5 163C443.94 163 437 169.94 437 178.5C437 187.06 443.94 194 452.5 194C461.06 194 468 187.06 468 178.5Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_204_1298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437 163H468V194H437V163Z",
    fill: "#DFD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.097 163H437V163.097H437.097V163Z",
    fill: "#E1D7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.281 183.344H445.719V184.312H459.281V183.344ZM459.281 184.312H445.719V185.281H459.281V184.312ZM459.281 185.281H445.719V186.25H459.281V185.281ZM459.281 186.25H445.719V187.219H459.281V186.25ZM447.656 187.219H445.719V188.188H447.656V187.219ZM459.281 187.219H448.625V188.188H459.281V187.219ZM447.656 188.188H445.719V189.156H447.656V188.188ZM459.281 188.188H448.625V189.156H459.281V188.188ZM447.656 189.156H445.719V190.125H447.656V189.156ZM459.281 189.156H448.625V190.125H459.281V189.156ZM447.656 190.125H445.719V191.094H447.656V190.125ZM459.281 190.125H448.625V191.094H459.281V190.125ZM447.656 191.094H445.719V192.062H447.656V191.094ZM459.281 191.094H448.625V192.062H459.281V191.094ZM447.656 192.062H445.719V193.031H447.656V192.062ZM459.281 192.062H448.625V193.031H459.281V192.062ZM447.656 193.031H445.719V194H447.656V193.031ZM459.281 193.031H448.625V194H459.281V193.031Z",
    fill: "#9F21A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.406 186.25H454.438V187.219H455.406V186.25ZM453.469 187.219H450.562V188.188H453.469V187.219Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.438 187.219H453.469V188.188H454.438V187.219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.406 187.219H454.438V188.188H455.406V187.219Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.375 187.219H455.406V188.188H456.375V187.219Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.562 188.188H449.594V189.156H450.562V188.188ZM452.5 188.188H451.531V189.156H452.5V188.188Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.469 188.188H452.5V189.156H453.469V188.188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.406 188.188H453.469V189.156H455.406V188.188ZM450.562 189.156H449.594V190.125H450.562V189.156ZM452.5 189.156H451.531V190.125H452.5V189.156Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.438 189.156H452.5V190.125H454.438V189.156Z",
    fill: "#F38B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.406 189.156H454.438V190.125H455.406V189.156ZM452.5 190.125H451.531V191.094H452.5V190.125ZM455.406 190.125H454.438V191.094H455.406V190.125Z",
    fill: "#FFF0EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.562 165.906H449.594V166.875H450.562V165.906ZM454.438 165.906H451.531V166.875H454.438V165.906ZM455.406 166.875H448.625V167.844H455.406V166.875ZM455.406 167.844H447.656V168.812H455.406V167.844Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.625 168.812H446.688V169.781H448.625V168.812Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.406 168.812H448.625V169.781H455.406V168.812Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.312 168.812H455.406V169.781H458.312V168.812ZM451.531 169.781H445.719V170.75H451.531V169.781Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.406 169.781H451.531V170.75H455.406V169.781Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.281 169.781H455.406V170.75H459.281V169.781ZM454.438 170.75H445.719V171.719H454.438V170.75Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.406 170.75H454.438V171.719H455.406V170.75Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.281 170.75H455.406V171.719H459.281V170.75ZM460.25 171.719H444.75V172.688H460.25V171.719ZM460.25 172.688H444.75V173.656H460.25V172.688ZM460.25 173.656H444.75V174.625H460.25V173.656ZM460.25 174.625H444.75V175.594H460.25V174.625ZM460.25 175.594H444.75V176.562H460.25V175.594ZM460.25 176.562H444.75V177.531H460.25V176.562ZM460.25 177.531H444.75V178.5H460.25V177.531ZM460.25 178.5H444.75V179.469H460.25V178.5ZM452.5 179.469H444.75V180.438H452.5V179.469Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.375 179.469H452.5V180.438H456.375V179.469Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.25 179.469H456.375V180.438H460.25V179.469ZM452.5 180.438H444.75V181.406H452.5V180.438Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.312 180.438H452.5V181.406H458.312V180.438Z",
    fill: "#F98F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.25 180.438H458.312V181.406H460.25V180.438ZM452.5 181.406H444.75V182.375H452.5V181.406Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.375 181.406H452.5V182.375H456.375V181.406Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.25 181.406H456.375V182.375H460.25V181.406ZM452.5 182.375H444.75V183.344H452.5V182.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.375 182.375H452.5V183.344H456.375V182.375Z",
    fill: "#E11833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.25 182.375H456.375V183.344H460.25V182.375Z",
    fill: "#F9F4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 173.656H446.688V174.625H452.5V173.656ZM459.281 173.656H453.469V174.625H459.281V173.656ZM447.656 174.625H446.688V175.594H447.656V174.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 174.625H447.656V175.594H449.594V174.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.531 174.625H449.594V175.594H451.531V174.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 174.625H451.531V175.594H452.5V174.625ZM454.438 174.625H453.469V175.594H454.438V174.625Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.375 174.625H454.438V175.594H456.375V174.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.312 174.625H456.375V175.594H458.312V174.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.281 174.625H458.312V175.594H459.281V174.625ZM447.656 175.594H443.781V176.562H447.656V175.594Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 175.594H447.656V176.562H449.594V175.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.531 175.594H449.594V176.562H451.531V175.594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.438 175.594H451.531V176.562H454.438V175.594Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.375 175.594H454.438V176.562H456.375V175.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.312 175.594H456.375V176.562H458.312V175.594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.281 175.594H458.312V176.562H459.281V175.594ZM444.75 176.562H443.781V177.531H444.75V176.562ZM447.656 176.562H446.688V177.531H447.656V176.562Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 176.562H447.656V177.531H449.594V176.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.531 176.562H449.594V177.531H451.531V176.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 176.562H451.531V177.531H452.5V176.562ZM454.438 176.562H453.469V177.531H454.438V176.562Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.375 176.562H454.438V177.531H456.375V176.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.312 176.562H456.375V177.531H458.312V176.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.281 176.562H458.312V177.531H459.281V176.562ZM444.75 177.531H443.781V178.5H444.75V177.531ZM447.656 177.531H446.688V178.5H447.656V177.531Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 177.531H447.656V178.5H449.594V177.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.531 177.531H449.594V178.5H451.531V177.531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 177.531H451.531V178.5H452.5V177.531ZM454.438 177.531H453.469V178.5H454.438V177.531Z",
    fill: "#F3322C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.375 177.531H454.438V178.5H456.375V177.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.312 177.531H456.375V178.5H458.312V177.531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.281 177.531H458.312V178.5H459.281V177.531ZM452.5 178.5H446.688V179.469H452.5V178.5ZM459.281 178.5H453.469V179.469H459.281V178.5Z",
    fill: "#F3322C"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M245 63V147",
    stroke: "#DFDFDF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M325 47L282 147",
    stroke: "#DFDFDF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M398 74L330 150",
    stroke: "#DFDFDF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M423 180L361 181",
    stroke: "#DFDFDF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137 186H59",
    stroke: "#DFDFDF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M142 147L64 79",
    stroke: "#DFDFDF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M196 147L155 71",
    stroke: "#DFDFDF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M145 163C145 161.343 146.343 160 148 160H175V174H145V163Z",
    fill: "#F9D8D8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M203 192H189C187.343 192 186 193.343 186 195V200C186 201.657 187.343 203 189 203H203C204.657 203 206 201.657 206 200V195C206 193.343 204.657 192 203 192Z",
    fill: "#DFF3E7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M212 227H198C196.343 227 195 228.343 195 230V235C195 236.657 196.343 238 198 238H212C213.657 238 215 236.657 215 235V230C215 228.343 213.657 227 212 227Z",
    fill: "#F9D8D8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M242 217H228C226.343 217 225 218.343 225 220V225C225 226.657 226.343 228 228 228H242C243.657 228 245 226.657 245 225V220C245 218.343 243.657 217 242 217Z",
    fill: "#FAE08D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M306 167.5H175",
    stroke: "#DFDFDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_204_1298",
    x: 137,
    y: 147,
    width: 214,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_1298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_1298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_204_1298",
    x: 214,
    y: -2,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.709804 0 0 0 0 0.913725 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_1298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_1298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_204_1298",
    x: 109,
    y: 14,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.619608 0 0 0 0 0.392157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_1298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_1298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_204_1298",
    x: 6,
    y: 28,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.843137 0 0 0 0 0.678431 0 0 0 0 0.239216 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_1298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_1298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_204_1298",
    x: -8,
    y: 150,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.231373 0 0 0 0 0.196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_1298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_1298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_204_1298",
    x: 312,
    y: -10,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.231373 0 0 0 0 0.196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_1298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_1298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_204_1298",
    x: 394,
    y: 23,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.643137 0 0 0 0 0.364706 0 0 0 0 0.505882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_1298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_1298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_204_1298",
    x: 422,
    y: 148,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.619608 0 0 0 0 0.392157 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_1298"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_1298",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_1298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 473,
    height: 252,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntiRaid);
export default __webpack_public_path__ + "static/media/antiRaid.74388dfa62fe7aadbd0888622ef4f92d.svg";
export { ForwardRef as ReactComponent };